// Si un ítem del menú se ve: el cargo puede entrar a su ruta. (Hasta M4·D1 un
// ítem podía depender además de un flag de plataforma; el único que lo hacía,
// `graduation_audit`, se retiró en el paso 5, y con él esa condición.)
//
// «Puede entrar» se pregunta con la MISMA ruta que usa la guarda de la página
// (`access`, si la página no se guarda con su propio camino). Si no, el menú
// muestra lo que la guarda después rechaza: pasó con el Tablón de Anuncios.

//
// Y el seminario USA el módulo de esa ruta (`pathEnabled`, modules.config). Sin
// módulos configurados, todas las rutas están encendidas: el menú de siempre.

export function isNavItemVisible(
  item: { path: string; access?: string },
  canAccess: (path: string) => boolean,
  pathEnabled: (path: string) => boolean = () => true,
): boolean {
  return canAccess(item.access ?? item.path) && pathEnabled(item.path);
}
